// Données fictives pour la maquette Performance (aucune connexion backend)

export const SERVICES = [
  { id: "stock_int", name: "Stock pièces intérieur", active: true },
  { id: "stock_ext", name: "Stock extérieur", active: true },
  { id: "exped_emb", name: "Expédition / emballage", active: true },
  { id: "exped_bur", name: "Expédition bureau", active: true },
  { id: "magasin", name: "Magasin", active: true },
  { id: "sav", name: "SAV", active: true },
  { id: "vhu", name: "Administratif VHU", active: true },
  { id: "demonteurs", name: "Démonteurs", active: true },
  { id: "expertise", name: "Expertise", active: true },
];

// unit: number | currency | percent | duration · dir: up (plus haut = mieux) | down
// source: MANUAL | CALCULATED | API
export const METRICS = [
  { id: "si_stock", service: "stock_int", name: "Pièces mises en stock", unit: "number", dir: "up", source: "MANUAL", target: 320 },
  { id: "si_prep", service: "stock_int", name: "Commandes préparées", unit: "number", dir: "up", source: "MANUAL", target: 260 },
  { id: "si_vendu", service: "stock_int", name: "Pièces vendues", unit: "number", dir: "up", source: "MANUAL", target: 240 },
  { id: "se_stock", service: "stock_ext", name: "Pièces mises en stock", unit: "number", dir: "up", source: "MANUAL", target: 180 },
  { id: "se_prep", service: "stock_ext", name: "Commandes préparées", unit: "number", dir: "up", source: "MANUAL", target: 150 },
  { id: "ee_exp", service: "exped_emb", name: "Pièces expédiées", unit: "number", dir: "up", source: "MANUAL", target: 400 },
  { id: "ee_ret", service: "exped_emb", name: "Retours", unit: "number", dir: "down", source: "MANUAL", target: 18 },
  { id: "ee_tx_ret", service: "exped_emb", name: "% retour", unit: "percent", dir: "down", source: "CALCULATED", formula: "ee_ret / ee_exp × 100", target: 4.5 },
  { id: "ee_tx_lit", service: "exped_emb", name: "% litige", unit: "percent", dir: "down", source: "CALCULATED", formula: "eb_lit / ee_exp × 100", target: 2 },
  { id: "eb_lit", service: "exped_bur", name: "Litiges ouverts", unit: "number", dir: "down", source: "MANUAL", target: 10, snapshot: true },
  { id: "eb_retard", service: "exped_bur", name: "Commandes en retard", unit: "number", dir: "down", source: "MANUAL", target: 12, snapshot: true },
  { id: "mg_ca", service: "magasin", name: "Chiffre d'affaires", unit: "currency", dir: "up", source: "API", target: 7800 },
  { id: "mg_vendu", service: "magasin", name: "Pièces vendues", unit: "number", dir: "up", source: "MANUAL", target: 95 },
  { id: "sav_nb", service: "sav", name: "Nombre de SAV", unit: "number", dir: "down", source: "MANUAL", target: 22 },
  { id: "sav_remb", service: "sav", name: "Demandes de remboursement", unit: "number", dir: "down", source: "MANUAL", target: 9 },
  { id: "vhu_in", service: "vhu", name: "Véhicules entrés", unit: "number", dir: "up", source: "MANUAL", target: 14 },
  { id: "dm_pieces", service: "demonteurs", name: "Pièces démontées", unit: "number", dir: "up", source: "MANUAL", target: 300 },
  { id: "dm_veh", service: "demonteurs", name: "Véhicules traités", unit: "number", dir: "up", source: "MANUAL", target: 12 },
  { id: "ex_veh", service: "expertise", name: "Véhicules expertisés", unit: "number", dir: "up", source: "MANUAL", target: 16 },
  { id: "ex_pieces", service: "expertise", name: "Pièces expertisées", unit: "number", dir: "up", source: "MANUAL", target: 140 },
];

export const COLLABORATEURS = [
  { id: "c1", name: "Karim B.", service: "stock_int" },
  { id: "c2", name: "Sofia M.", service: "stock_int" },
  { id: "c3", name: "Yann L.", service: "exped_emb" },
  { id: "c4", name: "Nadia R.", service: "demonteurs" },
  { id: "c5", name: "Hugo T.", service: "demonteurs" },
];

// Valeurs du jour / cumul semaine (5j) / cumul mois (21j) + période précédente
const BASE = {
  si_stock: 338, si_prep: 271, si_vendu: 232,
  se_stock: 164, se_prep: 158,
  ee_exp: 412, ee_ret: 15,
  eb_lit: 8, eb_retard: 17,
  mg_ca: 8240, mg_vendu: 102,
  sav_nb: 19, sav_remb: 7,
  vhu_in: 16,
  dm_pieces: 284, dm_veh: 11,
  ex_veh: 18, ex_pieces: 151,
};
const PREV = {
  si_stock: 312, si_prep: 284, si_vendu: 245,
  se_stock: 171, se_prep: 143,
  ee_exp: 389, ee_ret: 21,
  eb_lit: 11, eb_retard: 12,
  mg_ca: 7410, mg_vendu: 94,
  sav_nb: 24, sav_remb: 11,
  vhu_in: 13,
  dm_pieces: 301, dm_veh: 13,
  ex_veh: 15, ex_pieces: 128,
};

const FACTOR = { day: 1, week: 5, month: 21 };

export function metricValue(metricId, period) {
  const m = METRICS.find((x) => x.id === metricId);
  const f = FACTOR[period];
  if (m.source === "CALCULATED") {
    if (metricId === "ee_tx_ret") return round1((BASE.ee_ret / BASE.ee_exp) * 100);
    if (metricId === "ee_tx_lit") return round1((BASE.eb_lit / BASE.ee_exp) * 100);
    return null;
  }
  const raw = BASE[metricId];
  if (raw == null) return null;
  return m.snapshot ? raw : Math.round(raw * f);
}

export function metricPrev(metricId, period) {
  const m = METRICS.find((x) => x.id === metricId);
  const f = FACTOR[period];
  if (m.source === "CALCULATED") {
    if (metricId === "ee_tx_ret") return round1((PREV.ee_ret / PREV.ee_exp) * 100);
    if (metricId === "ee_tx_lit") return round1((PREV.eb_lit / PREV.ee_exp) * 100);
    return null;
  }
  const raw = PREV[metricId];
  if (raw == null) return null;
  return m.snapshot ? raw : Math.round(raw * f);
}

export function metricTarget(metricId, period) {
  const m = METRICS.find((x) => x.id === metricId);
  if (m.target == null) return null;
  if (m.unit === "percent" || m.snapshot) return m.target;
  return m.target * FACTOR[period];
}

export function formatValue(value, unit) {
  if (value == null || Number.isNaN(value)) return "—";
  if (unit === "currency") return `${value.toLocaleString("fr-FR")} €`;
  if (unit === "percent") return `${value.toLocaleString("fr-FR")} %`;
  if (unit === "duration") return `${value} min`;
  return value.toLocaleString("fr-FR");
}

const round1 = (n) => Math.round(n * 10) / 10;

export const TREND_SERIES = [
  { label: "22/09", expedies: 371, retours: 19 },
  { label: "23/09", expedies: 402, retours: 14 },
  { label: "24/09", expedies: 388, retours: 22 },
  { label: "25/09", expedies: 441, retours: 17 },
  { label: "26/09", expedies: 395, retours: 11 },
  { label: "29/09", expedies: 418, retours: 16 },
  { label: "30/09", expedies: 412, retours: 15 },
];

export const COLLAB_ROWS = [
  { name: "Karim B.", service: "Stock intérieur", stock: 128, prep: 96, ratio: 75 },
  { name: "Sofia M.", service: "Stock intérieur", stock: 112, prep: 89, ratio: 79 },
  { name: "Yann L.", service: "Expédition", stock: null, prep: 142, ratio: null },
  { name: "Nadia R.", service: "Démonteurs", stock: 148, prep: null, ratio: null },
  { name: "Hugo T.", service: "Démonteurs", stock: 136, prep: null, ratio: null },
];
